module.exports = __webpack_public_path__ + "static/media/No_photo_available.6c85d113.png";